import { CallLogsContainer } from "./style";

const CallLogs = () => {
  return (
    <CallLogsContainer>
      <div>call logs is still in development</div>
    </CallLogsContainer>
  );
};
export default CallLogs;
